import React from "react";
import { Tag } from "antd";

import { ORDRE_STATUTS, STATUTS, formaterDateHeure, statutModule } from "./cartographieDonnees";

// Badge unique de statut d'un module (meme libelle et meme couleur dans les trois vues).
export function StatutBadge({ module: m, className }) {
  const st = statutModule(m);
  return (
    <Tag color={STATUTS[st].tag} className={className} data-statut={st}>
      {STATUTS[st].label}
    </Tag>
  );
}

// Legende commune des 5 statuts.
export function LegendeStatuts() {
  return (
    <div className="carto-legende" data-testid="legende-statuts">
      {[...ORDRE_STATUTS].reverse().map((k) => (
        <span key={k} data-statut={k}>
          <span className="carto-dot" style={{ background: STATUTS[k].couleur }} />
          {STATUTS[k].label}
        </span>
      ))}
    </div>
  );
}

// Dates de l'environnement : dernier changement des settings et derniere activite (logs, 30 j).
export function InfosEnv({ env: e }) {
  const modifie = formaterDateHeure(e.settings_changed_at);
  const activite = formaterDateHeure(e.last_activity_at);
  return (
    <>
      <span className="carto-nb">{modifie ? `Settings modifiés le ${modifie}` : "aucun relevé de settings"}</span>
      <span className="carto-nb">{activite ? `Dernière activité le ${activite}` : "aucune activité sur 30 j"}</span>
    </>
  );
}

